import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatBusinessDate } from './time';

const BulkSettlementDatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [businessDate, setBusinessDate] = useState(formatBusinessDate(new Date()));

  const handleContinue = () => {
    if (!businessDate) return;
    navigate('/cashier/settings/bulk-settlement/transactions', { state: { businessDate } });
  };

  return (
    <div className="cashier-heading-innner">
      <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
        <h4 className="heading-title-text">{t('label_bulk_settlement')}</h4>
      </div>

      <div className="dashboard-content-wraper">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-end gap-3" style={{ maxWidth: '480px' }}>
              <div className="flex-grow-1">
                <label className="form-label">{t('label_date')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={businessDate}
                  max={formatBusinessDate(new Date())}
                  onChange={e => setBusinessDate(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="btn text-white"
                style={{ backgroundColor: '#ff9500', borderColor: '#ff9500' }}
                disabled={!businessDate}
                onClick={handleContinue}
              >
                {t('btn_continue')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkSettlementDatePage;
